// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"590":"a10be132","724":"a2f4c295"}[chunkId] + ".chunk.css";
};